import CircleChartIcon from './component'

export default CircleChartIcon
